import styles from "./EmbedLayout.module.scss";

import { useEffect } from "react";

import { Outlet } from "@tanstack/react-router";

export function EmbedLayout() {
  useEffect(() => {
    const selector = 'meta[name="viewport"][data-zoom-supressor]';
    let meta = document.querySelector(selector) as HTMLMetaElement | null;

    if (!meta) {
      meta = document.createElement("meta");
      meta.setAttribute("name", "viewport");
      meta.setAttribute(
        "content",
        "width=device-width, initial-scale=1, maximum-scale=1, user-scalable=0",
      );
      meta.setAttribute("data-zoom-supressor", "true");
      document.head.appendChild(meta);
    }

    return () => {
      if (meta?.getAttribute("data-zoom-supressor") === "true") {
        meta.remove();
      }
    };
  }, []);

  return (
    <div className={styles.layout}>
      <main className={styles.main}>
        <Outlet />
      </main>
    </div>
  );
}
